import React from 'react';
import { useAuth } from '../context/AuthContext';
import { LogOut, User } from 'lucide-react';
import { getDisplayName } from '../utils/admin';

const Header = () => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white shadow-sm h-16 flex items-center justify-between px-6 sticky top-0 z-10">
      <div className="text-lg font-semibold text-gray-800">
        {/* Optional: Breadcrumbs or page title could go here */}
      </div>
      
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2 text-gray-700">
          <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
            <User size={20} className="text-gray-500" />
          </div>
          <div className="hidden md:block">
            <p className="text-sm font-medium">{getDisplayName(user, 'Admin User')}</p>
            <p className="text-xs text-gray-500 capitalize">{user?.role || 'Admin'}</p>
          </div>
        </div>
        
        <button 
          onClick={logout}
          className="p-2 text-gray-500 hover:text-red-600 transition-colors rounded-full hover:bg-red-50"
          title="Logout"
        >
          <LogOut size={20} />
        </button>
      </div>
    </header>
  );
};

export default Header;
